import type { RouteName } from '@jira/platform__routing-route-name-types/src/RouteName.tsx';
import type { JiraSpaRoute, Match, RouterContext } from '@atlassian/react-resource-router';
import { MENU_ID_HELP_CENTER_MANAGEMENT } from '../../../constants.tsx';
import type { SelectedPath } from '../../../types.tsx';

const routes = new Set<RouteName>(['helpcenter-management', 'helpcenter-management-settings']);

function convert(routeContext: RouterContext<JiraSpaRoute>): SelectedPath {
	const routeName: RouteName = routeContext.route.name;
	return convertRouteToPath({ routeName, match: routeContext.match });
}

function convertNew(args: { routeName: RouteName; match: Match }): SelectedPath {
	const { routeName, match } = args;
	return convertRouteToPath({ routeName, match });
}

function convertRouteToPath(args: { routeName: RouteName; match: Match }): SelectedPath {
	const { routeName } = args;
	const path: string[] = [];

	switch (routeName) {
		case 'helpcenter-management':
		case 'helpcenter-management-settings':
			path.push(MENU_ID_HELP_CENTER_MANAGEMENT);
			break;
		default:
	}

	return path;
}

export const helpCenterManagementConverter: {
	routes: Set<RouteName>;
	convert: typeof convert;
	convertNew: typeof convertNew;
} = { routes, convert, convertNew };
